<template>
  <generic-modal
    :title="$t('execute script')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div>
      <div class="title is-5">{{ script.name }}</div>
      <div
        class="subtitle is-6"
        v-if="script.arguments && script.arguments.length"
      >
        {{ $t("enter arguments value") }}
      </div>
      <!-- <pre>{{ script }}</pre> -->
      <article
        class="message is-warning"
        v-if="!script.arguments || !script.arguments.length"
      >
        <div class="message-body">
          {{ $t("this script does not require any arguments") }}
        </div>
      </article>
      <div class="field" v-for="arg in script.arguments" :key="arg.name">
        <label class="label">{{ arg.name }}</label>
        <input class="input" type="text" v-model="args[arg.name]" />
      </div>
    </div>
    <div v-if="result" class="pt-5">
      <div class="title is-5 mb-2">{{ $t("execution result") }}</div>
      <pre>{{ result }}</pre>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="execute"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-bolt"></i>
        </span>
        <span>{{ $t("execute") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ExecuteModal",
  components: { GenericModal },
  data() {
    return {
      script: {},
      error: "",
      args: {},
      result: undefined,
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(script) {
      let v = this;
      v.set_initial_state();
      v.script = script;
      let args = script.arguments || [];
      v.args = args.reduce((acc, arg) => {
        acc[arg.name] = "";
        return acc;
      }, {});
      v.$refs.generic_modal.show_modal();
    },
    execute() {
      let v = this;
      put("/script", { directory: v.script.directory, args: v.args })
        .then((rspns) => {
          v.result = rspns;
          // v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.script = {};
      v.error = "";
      v.result = undefined;
      v.args = {};
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
